import React, { memo } from 'react';
import { Control, Controller, FieldPath } from 'react-hook-form';
import { TextInput } from '@tcc/crate';
import { Tooltip, ElementSide } from '@tcc/fds';
import { inferUnit } from 'util/unitConversion';
import { convertPlantingPlanParams } from 'util/parse';
import { getMessage } from 'util/locale';
import { FormData } from '../../types';

interface PopulationInputCellProps {
  control: Control<FormData>;
  name: FieldPath<FormData>;
  rowIndex: number;
  disabled?: boolean;
  showTooltip?: boolean;
}

export const PopulationInputCell = memo(function Cell({
  control,
  name,
  rowIndex,
  disabled,
  showTooltip,
}: PopulationInputCellProps) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState: { error } }) => {
        const { display } = convertPlantingPlanParams({
          validationResult: undefined,
          value: field.value,
          currency: null
        });

        const input = (
          <TextInput
            error={error?.message as string}
            onChange={(e) => field.onChange(e.target.value)}
            onBlur={field.onBlur}
            placeholder={`0 ${inferUnit('seed-density').symbol.quantitySpecific}`}
            testId={`avg-fixed-pop-input-${rowIndex}`}
            value={display}
            showReset={false}
            className="script-generation-row-input"
            disabled={disabled}
          />
        );

        if (showTooltip) {
          return (
            <Tooltip
              testId={`avg-fixed-pop-locked-tooltip-${rowIndex}`}
              placement={ElementSide.Bottom}
              trigger={<span>{input}</span>}
            >
              {getMessage('bulk-fvss-script-generation-locked-input-tooltip')}
            </Tooltip>
          );
        }

        return input;
      }}
    />
  );
});
